import { render, staticRenderFns } from "./school-payments.vue?vue&type=template&id=48664a84"
import script from "./school-payments.vue?vue&type=script&lang=ts"
export * from "./school-payments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports